module.exports = __webpack_public_path__ + "static/img/icon_1.f11dd8fd.png";